
import Vue, { PropType } from 'vue';
import CandidateService, { Candidate, WorkAuthorization } from '~/services/CandidateService';
import IdentityService, { User } from '~/services/IdentityService';
import { ProfileTab } from './ProfileTabs.vue';
import {
    CandidateProfileScore,
    CandidateProfileScorer,
} from '~/utils/candidate/CandidateProfileScorer';
import CV from '../documents/components/CV.vue';
import ProfileSkeleton from './ProfileSkeleton.vue';
import ProfileWrapper from './ProfileWrapper.vue';

export default Vue.extend({
    name: 'ProfileDocuments',
    components: {
        ProfileWrapper,
        ProfileSkeleton,
        CV,
    },
    props: {
        tabs: {
            type: Array as PropType<ProfileTab[]>,
            required: false,
        },
    },
    data() {
        return {
            identityService: new IdentityService(),
            candidateService: new CandidateService(),

            user: null as User | null,
            candidate: null as Candidate | null,
            workAuthorizations: [] as WorkAuthorization[],
            profileScore: null as CandidateProfileScore | null,
        };
    },
    computed: {
        isLoading(): boolean {
            return !this.user || !this.candidate || !this.workAuthorizations;
        },
    },
    methods: {
        async loadUser() {
            this.user = await this.identityService.getMe();
        },
        async loadCandidate() {
            this.candidate = await this.candidateService.getMe();
        },
        async loadWorkAuthorizations() {
            this.workAuthorizations = await this.candidateService.getWorkAuthorizations();
        },
        async refresh(initialLoad = false) {
            if (initialLoad) {
                const user = this.$store.getters['profileModule/getUser']();
                const candidate = this.$store.getters['profileModule/getCandidate']();
                const workAuthorizations =
                    this.$store.getters['profileModule/getWorkAuthorizations']();
                if (user && candidate && workAuthorizations) {
                    this.user = user;
                    this.candidate = candidate;
                    this.workAuthorizations = workAuthorizations;
                    this.calculateProfileScore();
                    return;
                }
            }

            Promise.all([
                this.loadUser(),
                this.loadCandidate(),
                this.loadWorkAuthorizations(),
            ]).then(([user, candidate, workAuthorizations]) => {
                this.calculateProfileScore();
                this.$store.commit('profileModule/setUser', user);
                this.$store.commit('profileModule/setCandidate', candidate);
                this.$store.commit('profileModule/setWorkAuthorizations', workAuthorizations);
            });
        },
        refreshProfile() {
            this.refresh(false);
        },
        calculateProfileScore() {
            if (this.candidate && this.user && this.workAuthorizations) {
                this.profileScore = new CandidateProfileScorer(
                    this.candidate,
                    this.user,
                    this.workAuthorizations
                ).getProfileScore();
            }
        },
    },

    mounted() {
        this.refresh(true);
        window.addEventListener('candidate:profile:update', this.refreshProfile);
    },
    beforeDestroy() {
        window.removeEventListener('candidate:profile:update', this.refreshProfile);
    },
});
